<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app light stateless v-if="showNav">
      <v-list dense>
        <v-list-item @click="goHome">
          <v-list-item-action>
            <v-icon>mdi-cash-usd-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Overblik</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-icon>mdi-chart-donut</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Statistik</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click.prevent="logoutMethod">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Log af</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app color="primary" dark elevation="0" key="bar" v-if="showNav">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="showNav"></v-app-bar-nav-icon>
      <v-btn icon v-else ref="back" @click.prevent="goBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>Bigspender</v-toolbar-title>
      <v-spacer />
      <v-btn icon @click="refresh">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content key="content">
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
import Eventbus from '@/Eventbus';

export default {
  props: {
    source: String
  },
  data: () => ({
    drawer: null
  }),
  computed: {
    showNav() {
      if (this.$route.name !== "login") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goHome() {
      this.drawer = null;
      this.$router.push({ name: "home" });
    },
    logoutMethod() {
      this.logout();
      this.drawer = null;
    },
    refresh() {
      Eventbus.$emit('update-data');
    },
    ...mapActions(["logout"])
  }
};
</script>
